import React, { useEffect, useState } from 'react';
import { Button } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { RouterProvider } from "react-router-dom";
import awsconfig from '../aws-exports';

export default function FederatedAuthenticator({ router }) {
  const [user, setUser] = useState(null);

  const env = awsconfig.oauth.domain.includes('prod') ? 'prod' : 'stage';

  const getProvider = () => {
    return env === 'stage' ? 'yf-hf-azure-stage' : 'yf-hf-azure-prod';
  };

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setUser(user);
    } catch (error) {
      console.log('error checking user: ', error);
    }
  };

  const federatedSignIn = async () => {
    try {
      await Auth.federatedSignIn({ provider: getProvider() });
      checkUser();
    } catch (error) {
      console.log('error signing in: ', error);
    }
  };

  const federatedSignOut = async () => {
    try {
      await Auth.signOut();
      setUser(null);
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };

  return (
    <div className="App">
      {user ? (
        <>
          <p>Hello {user.attributes.given_name} {user.attributes.family_name}</p>
          <Button className="sign-out-btn" onClick={() => federatedSignOut()}>
            Sign out
          </Button>
          <RouterProvider router={router} />
        </>
      ) : (
        <Button onClick={federatedSignIn}>Sign in with Azure</Button>
      )}
    </div>
  );
}
